'use client'

import Link from 'next/link'
import Image from 'next/image'
import { ArrowRightIcon } from './icons'

export function PetSelectSeasonalPromo() {
  return (
    <section className="py-14 md:py-18 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {/* Promo 1 */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0B7A75] to-[#065A55] p-8 md:p-10 min-h-[240px] flex flex-col justify-end">
            <div className="absolute top-0 right-0 w-1/2 h-full opacity-20">
              <Image
                src="/images/petselect/lifestyle/dogs-playing.jpg"
                alt="Dogs playing"
                fill
                className="object-cover"
                sizes="300px"
              />
            </div>
            <p className="text-[#FF6B35] text-xs font-bold tracking-widest uppercase mb-2 relative z-10">This Season</p>
            <h3 className="text-xl md:text-2xl font-bold text-white mb-2 relative z-10">
              Summer Essentials
            </h3>
            <p className="text-white/70 text-sm mb-4 max-w-xs relative z-10">
              Keep your pets cool and happy with our summer collection. Cooling mats, fresh treats & more.
            </p>
            <Link
              href="/store"
              className="inline-flex items-center gap-2 text-white font-semibold text-sm relative z-10 hover:gap-3 transition-all"
            >
              Shop Now <ArrowRightIcon className="w-3.5 h-3.5" />
            </Link>
          </div>

          {/* Promo 2 */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-100 p-8 md:p-10 min-h-[240px] flex flex-col justify-end">
            <div className="absolute top-0 right-0 w-1/2 h-full opacity-20">
              <Image
                src="/images/petselect/lifestyle/cat-looking.jpg"
                alt="Cat with treats"
                fill
                className="object-cover"
                sizes="300px"
              />
            </div>
            <p className="text-[#0B7A75] text-xs font-bold tracking-widest uppercase mb-2 relative z-10">New Arrivals</p>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 relative z-10">
              Premium Cat Nutrition
            </h3>
            <p className="text-gray-500 text-sm mb-4 max-w-xs relative z-10">
              Discover our latest range of vet-approved, grain-free cat food from Australia&apos;s best brands.
            </p>
            <Link
              href="/categories/cat"
              className="inline-flex items-center gap-2 text-[#0B7A75] font-semibold text-sm relative z-10 hover:gap-3 transition-all"
            >
              Explore <ArrowRightIcon className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
